import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { noPaddingAllTypes } from "../../constants";

function Box({ style, padding, margin, className, children }) {
  const classNameBox = classNames(
    "box",
    {
      [`padding-${padding}`]: padding,
      [`margin-${margin}`]: margin
    },
    className
  );

  return React.createElement(
    "div",
    {
      className: classNameBox,
      style: style
    },
    children
  );
}

Box.defaultProps = {
  style: null,
  padding: null,
  margin: null,
  className: "",
  children: null
};

Box.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType(PropTypes.string, PropTypes.number)
  ),
  padding: PropTypes.oneOf(noPaddingAllTypes),
  margin: PropTypes.oneOf(["no"]),
  className: PropTypes.string,
  children: PropTypes.node
};

export default Box;
